<template>
  <v-menu
    v-model="dateModel"
    ref="dateModel"
    :return-value.sync="date"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="auto"
    :disabled="disabled || readonly"
    :readonly="readonly"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :dense="dense"
        v-model="date"
        :label="label"
        prepend-icon="mdi-calendar"
        v-bind="attrs"
        :hide-details="details ? false : hideDetails"
        v-on="on"
        :clearable="clearable"
        :rules="rules"
        :disabled="disabled"
        :readonly="readonly"
      ></v-text-field>
    </template>
    <v-date-picker
      v-model="date"
      :readonly="readonly"
      :first-day-of-week="1"
      no-title
      :hide-details="hideDetails"
      scrollable
      :color="color"
      :min="min"
      :max="max"
      :allowed-dates="allowedDates"
      :type="type"
      :events="events"
      :disabled="disabled"
      @change="onDatePickerChange"
      @update:picker-date="onUpdatePickerDate"
    >
      <div v-if="showButtons">
        <v-spacer></v-spacer>
        <v-btn
          class="my-1"
          color="primary"
          text
          @click="onDatePickerCancelClick"
        >
          Cancel
        </v-btn>
        <v-btn
          class="my-1 mx-1"
          color="primary"
          @click="onDatePickerOkClick"
        >
          OK
        </v-btn>
      </div>
    </v-date-picker>
  </v-menu>
</template>
<script>

export default {
  name: 'DatePicker',
  components: {
  },
  props: {
    value: {
      required: false
    },
    label: {
      required: false
    },
    showButtons: {
      required: false,
      type: Boolean,
      default: false
    },
    color: {
      required: false
    },
    min: {
      required: false
    },
    max: {
      required: false
    },
    allowedDates: {
      required: false
    },
    type: {
      required: false
    },
    events: {
      required: false
    },
    rules: {
      required: false
    },
    disabled: {
      required: false,
      default: false
    },
    dense: {
      required: false,
      type: Boolean,
      default: false
    },
    clearable: {
      required: false,
      type: Boolean,
      default: false
    },
    hideDetails: {
      required: false,
      default: 'auto'
    },
    readonly: {
      required: false,
      type: Boolean,
      default: false
    },
    details: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dateModel: false
    }
  },
  computed: {
    date: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val || null)
      }
    }
  },
  mounted () {
    this.$emit('input', this.date)
  },
  methods: {
    onDatePickerOkClick () {
      this.$refs.dateModel.save(this.date)
      this.$emit('onDatePickerOkClick')
      this.dateModel = false
    },
    onDatePickerCancelClick () {
      this.dateModel = false
    },
    onDatePickerMenuClose () {
      this.$emit('onDatePickerMenuClose')
      this.dateModel = false
    },
    onDatePickerChange (date) {
      this.$refs.dateModel.save(date)
      this.$emit('onDatePickerChange')
      this.dateModel = false
    },
    onUpdatePickerDate (date) {
      this.$emit('onUpdatePickerDate', date)
    }
  }
}
</script>
